import { useEffect } from 'react';
import { useSetAtom, useAtomValue } from 'jotai';
import Stack from '@mui/material/Stack';
import { PageLoader } from '@/components/shared/PageLoader';
import { TemplateForm } from '../TemplateForm';
import { FormTypes } from '../constants';
import {
  selectedCostLogsTemplateId,
  selectedTemplateId,
  selectedWorklogsTemplateId,
  selectedLogsTemplateType,
} from '../state';
import { LogTemplateType, useAllLogsTemplatesByTypeQuery } from '@/__generated__/graphql';

type LogsTemplatesListProps = {
  structureId: string;
  currentStructureName: string;
};

export const LogsTemplatesList = ({
  structureId,
  currentStructureName,
}: LogsTemplatesListProps) => {
  const selectedAssemblyTemplateId = useAtomValue(selectedTemplateId);
  const setWorklogsTemplateId = useSetAtom(selectedWorklogsTemplateId);
  const setCostLogsTemplateId = useSetAtom(selectedCostLogsTemplateId);
  const selectedTemplateType = useAtomValue(selectedLogsTemplateType);

  const { data: allLogsTemplates, loading: isLoading } = useAllLogsTemplatesByTypeQuery({
    variables: {
      input: {
        structureId,
        type: selectedTemplateType,
      },
    },
    skip: !structureId || !selectedAssemblyTemplateId,
    fetchPolicy: 'cache-first',
  });

  useEffect(() => {
    const templates = allLogsTemplates?.allLogsTemplates;
    if (templates) {
      const nextTemplateId = templates.at(0)?.id;
      if (selectedTemplateType === LogTemplateType.CostLogTemplate) {
        setCostLogsTemplateId(nextTemplateId);
      } else if (selectedTemplateType === LogTemplateType.WorklogTemplate) {
        setWorklogsTemplateId(nextTemplateId);
      }
    }
  }, [
    allLogsTemplates?.allLogsTemplates,
    selectedTemplateType,
    setCostLogsTemplateId,
    setWorklogsTemplateId,
  ]);

  return (
    <Stack>
      {isLoading && <PageLoader />}
      {!isLoading && (
        <TemplateForm
          currentTemplateType={FormTypes.Logs.toString()}
          structureId={structureId}
          currentStructureName={currentStructureName}
        />
      )}
    </Stack>
  );
};
